// src/common/ReportStatusBadge.jsx
import Badge from "./Badge";

export default function ReportStatusBadge({ submitted = 0, total = 0 }) {
  const isComplete = submitted === total && total > 0;
  const hasPartial = submitted > 0 && submitted < total;

  const color = isComplete ? "success" : hasPartial ? "warning" : "danger";

  return (
    <Badge color={color}>
      {submitted}/{total} REPORTS SUBMITTED
    </Badge>
  );
}
